<div class="status" [ngClass]="status">
  <p>{{ title }} <span class="status-extra"><ng-content></ng-content></span></p>
</div>
